import { useMemo } from "react";
import { useSavedExportSettingsQuery } from "../../api";
import { useBulkExportContext } from "../../providers";
import { virtualConfiguration } from "../BulkExportStepper";
import { useDeleteBulkExportStateMutation } from "../../api/mutations/deleteBulkExportState";
import { sortBy } from "lodash";
import { BulkExportFormat } from "../../types";
import { BulkExportFormatEnum } from "../../api/mutations/saveBulkExportState/saveBulkExportState.types";

export function useDeleteSettingsButton() {
  const context = useBulkExportContext();

  const state = context?.state;
  const actions = context?.actions;
  const { savedExportSettingsId } = state ?? {};
  const configuration = state?.dimensions.find((d) => d.id === virtualConfiguration.hierarchyIdentifier);
  const { isSavedExportSettingsLoading, savedExportSettings, refetchSavedExportSettings } = useSavedExportSettingsQuery();
  const { deleteBulkExportSettings } = useDeleteBulkExportStateMutation();

  return useMemo(() => {
    const deleteExportSettings = () => {
      savedExportSettingsId && deleteBulkExportSettings(savedExportSettingsId);
      
      setTimeout(() => {
        refetchSavedExportSettings();
      }, 1000);
    };
    const nameOfSettings = savedExportSettings?.find((el) => el.id === savedExportSettingsId)?.name || "";

    return { deleteExportSettings, nameOfSettings };
  }, [deleteBulkExportSettings, state, isSavedExportSettingsLoading, savedExportSettings, configuration]);
}
